import { render, staticRenderFns } from "./CarrierInfo.vue?vue&type=template&id=30f4635a&"
import script from "./CarrierInfo.vue?vue&type=script&lang=js&"
export * from "./CarrierInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports